import { RouteConfig } from "vue-router";
import localizationFactory from "@/router/modules/localization-factory";

export default Array<RouteConfig>(
	{
		path: "/",
		name: "Counterparties",
		meta: localizationFactory('menu.contract', {
			layout: "main",
		}),
		component: () => import('../../views/Counterparties/Counterparties.vue'),
		children: [
			{
				path: ":id",
				name: "IBCounterparties-content",
				meta: {
					layout: "main"
				},
				props: true,
			}
		]
	},
	{
		path: "added-counterparties",
		name: "AddedCounterparties",
		meta: localizationFactory('counterparties.addCounterparties.header', {
			layout: "main",
			className: "header-sm-none"
		}),
		component: () => import('../../views/Counterparties/AddedCounterparties.vue')
	}
);